import type { IForm } from '$/types/components/forms';
import type { FieldError } from 'react-hook-form';
import type { RegisterOptions } from 'react-hook-form/dist/types/validator';

import get from 'lodash/get';

import {
  defaultErrorMessage as globalDefaultErrorMessage,
  messageByType,
} from '$/types/enums/ErrorMessages';
import { noErrorType } from '$/types/enums/TestTypes';

type TGetControlError = (
  control: IForm<any>['control'],
  name: string,
  defaultErrorMessage?: string | JSX.Element | undefined | null
) => Omit<FieldError, 'message'> & { message: string | JSX.Element };

const getControlError: TGetControlError = (
  control,
  name,
  fallbackErrorMessage
) => {
  return ((): ReturnType<TGetControlError> => {
    const error: ReturnType<TGetControlError> | undefined = get(
      control?._formState?.errors,
      name
    );
    if (error) {
      const errorType = error.type as keyof RegisterOptions;
      if (messageByType[errorType]) {
        return {
          ...error,
          message: messageByType[errorType]?.(error.message) ?? error.message,
        };
      }
      return error;
    }

    if (fallbackErrorMessage) {
      return { type: noErrorType, message: fallbackErrorMessage };
    }

    return { type: noErrorType, message: globalDefaultErrorMessage };
  })();
};

export default getControlError;
